webpackJsonp([162898551421021],{

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h1",
	      null,
	      "NOT FOUND"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "You just hit a route that doesn't exist... the sadness."
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-cf325d2e9bf981eec2f6.js